function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withParams } from '@finect/front-core/withParams';
import { Redirect } from '@finect/front-core/Routes';
import { withTheme } from 'styled-components';
import { SecurityHeader, FundSRRI, FundTimeseriesChart, FundSameCategoryFunds, FundSameManagementCompanyFunds, FundGettingStarted, FundDistributors, FundScatterComparisonChart, FundBreakdowns, FundPerformanceCharts, ProductHighlightsTable, FundRatios } from '@finect/tabular-components/Modules';
import { ProductSummary, InformationSource } from '@finect/tabular-components/Products';
import { Head } from '@finect/tabular-components/Head';
import { NotFound } from '@finect/tabular-components/NotFound';
import { Container } from '@finect/tabular-core/Container';
import { ContainerInner } from '@finect/tabular-core/ContainerInner';
import { MainContent } from '@finect/tabular-core/MainContent';
import { Side } from '@finect/tabular-core/Side';
import { Datalayer, DatalayerScene } from '@finect/front-gtm';
import { withSubscriptions } from '@finect/front-core/User';
import { isNode } from '@finect/front-utils/isNode';
import { getProductTypeBySlug, getProductTitle, getProductAction, getFundsSheetPath } from '@finect/front-resources/Products';
import { setProductRequest } from '../commons/store/products/actions';
import { gettingStarted } from '../commons/IIC/gettingStarted';
import { FamilyInsideNavigation } from '../commons/IIC/components';
import { fetchFund, clearFund, getCategories, getFundsByIdManagementCompany, getFundsByCategory, getManagementCompany } from '../commons/store/fund/actions';
import { withContext } from '../commons/hocs';
import { getSchemaORG } from './utils';
import { AsideWatchlistBlock, FundSheetSkeleton, Sticky } from './partials';
import { ProductVideo } from './components';
const getProductMetadescription = (product, productType) => `Rentabilidad, cartera, review y preguntas sobre el ${productType.shortSingular} ${product.name}`;
const mapStateToProps = state => ({
  notFound: state.fund.fund.notFound,
  omniNavState: 'opened',
  user: state.user.user,
  fund: state.fund.fund.model,
  fetching: state.fund.fund.fetching,
  category: state.fund.category,
  categories: state.fund.categories,
  fundsByManagementCompany: state.fund.fundsByManagementCompany,
  fundsByCategory: state.fund.fundsByCategory,
  productPage: state.products.productPage
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    getManagementCompany,
    fetchFund,
    clearFund,
    getCategories,
    getFundsByIdManagementCompany,
    getFundsByCategory,
    setProductRequest
  }, dispatch)
});
const CONTEXT_ID = 'producto';
class FundsSheet extends React.Component {
  constructor() {
    var _this;
    super(...arguments);
    _this = this;
    _defineProperty(this, "getProduct", () => ({
      subtype: this.props.fund.subtype,
      entity: this.props.fund
    }));
    _defineProperty(this, "handleListFollow", (product, follow) => {
      this.props.handleEntityFollow('product', 'subscribe', product, follow);
    });
    _defineProperty(this, "handleFollow", follow => {
      this.props.handleEntityFollow('product', 'subscribe', this.props.fund.id, follow);
    });
    _defineProperty(this, "handleProductRequest", function () {
      let commercialization = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      let flow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      _this.props.actions.setProductRequest(_this.getProduct(), commercialization, flow);
    });
  }
  static loadInitialData(store, cookies, match) {
    const productType = getProductTypeBySlug(match.params.typeSlug);
    return store.dispatch(fetchFund(productType, match.params.isin));
  }
  componentWillUnmount() {
    this.props.actions.clearFund();
  }
  componentDidUpdate(prevProps) {
    const {
      location
    } = this.props;
    const productType = getProductTypeBySlug(this.props.match.params.typeSlug);
    if (this.props.match.params.isin !== prevProps.match.params.isin) {
      this.props.actions.clearFund();
      return this.props.actions.fetchFund(productType, this.props.match.params.isin);
    }
    if (this.props.fund.managementCompany) {
      if (!this.props.fundsByManagementCompany.fetched) {
        this.props.actions.getFundsByIdManagementCompany(productType, this.props.fund.managementCompany.id);
      }
    }
    if (this.props.fund.category) {
      if (!this.props.fundsByCategory.fetched) {
        this.props.actions.getFundsByCategory(productType, this.props.fund.category.id);
      }
    }
    if (!prevProps.fund.hasOwnProperty('id') && this.props.fund.id) {
      this.props.contextActions.setContext(CONTEXT_ID, this.props.fund, location.search);
    }
  }
  componentDidMount() {
    const product = this.getProduct();
    const productType = getProductTypeBySlug(this.props.match.params.typeSlug);
    if (!this.props.fund.id) {
      window && window.scrollTo(0, 0);
      this.props.actions.fetchFund(productType, this.props.match.params.isin);
    }
    if (this.props.fund.id) {
      this.props.contextActions.setContext(CONTEXT_ID, this.props.fund, location.search);
    }
    const transactionable = product.hasOwnProperty('entity') && product.entity.transactionable;
    if (Object.keys(this.props.params).includes('lead') && transactionable) {
      this.handleProductRequest();
    }
  }
  render() {
    const productType = getProductTypeBySlug(this.props.match.params.typeSlug);
    const currentUrl = this.props.match.url;
    const {
      notFound,
      fund,
      fundsByManagementCompany,
      fundsByCategory,
      contextProps,
      getContextModelPath,
      getContextModelName,
      theme
    } = this.props;
    const product = this.getProduct();
    if (notFound) {
      return React.createElement(NotFound, this.props);
    }
    if (!this.props.fund.id) {
      return React.createElement(FundSheetSkeleton, null);
    }
    if (isNode() && this.props.match.params.alias !== this.props.fund.alias) {
      return React.createElement(Redirect, _extends({}, this.props, {
        status: 301,
        to: getFundsSheetPath(theme, productType, fund)
      }));
    }
    const distributors = product.hasOwnProperty('entity') ? product.entity.commercializations.filter(commercialization => commercialization.relationship === 'distributor' && commercialization.organization.alias !== 'ironia') : [];
    const transactionable = product.hasOwnProperty('entity') && product.entity.transactionable && distributors.length;
    const contextOrdered = Object.keys(this.props.params).map(key => contextProps.context.find(item => item.id === key)).filter(element => element);
    const fundTitle = getProductTitle(fund, productType);
    const fundDescription = getProductMetadescription(fund, productType);
    return React.createElement(React.Fragment, null, React.createElement(Head, {
      title: fundTitle,
      description: fundDescription,
      canonical: getFundsSheetPath(theme, productType, fund),
      schemaORG: getSchemaORG(fundTitle, fundDescription, fund)
    }), React.createElement(DatalayerScene, {
      pageType: "product",
      pageId: this.props.fund.id
    }), React.createElement(Datalayer, {
      id: "Fund",
      type: "view",
      params: {
        fund: this.props.fund
      }
    }), React.createElement(Container, null, React.createElement(FamilyInsideNavigation, {
      productType: productType,
      current: "sheet",
      currentUrl: currentUrl,
      onFollow: this.handleFollow,
      action: {
        text: getProductAction(product).action,
        disabled: !transactionable,
        onClick: () => this.handleProductRequest()
      },
      context: {
        contextOrdered,
        getContextModelName,
        getContextModelPath
      }
    })), React.createElement(Container, null, React.createElement(ContainerInner, null, React.createElement(MainContent, null, React.createElement(SecurityHeader, {
      fund: fund,
      product: product,
      withReviews: false,
      isPartner: true
    }), React.createElement(FundSRRI, {
      user: this.props.user,
      fund: fund
    }))), React.createElement(ContainerInner, {
      reverse: true
    }, React.createElement(MainContent, null, React.createElement(FundTimeseriesChart, {
      fund: fund,
      bottomMargin: true,
      withComparison: false
    }), React.createElement(FundDistributors, {
      bottomMargin: true,
      isPartner: true,
      fund: fund,
      product: product,
      onProductRequest: (commercialization, flow) => {
        this.handleProductRequest(commercialization, flow);
      },
      userBanks: [],
      userBankState: {
        fetched: true,
        fetching: false
      },
      banks: []
    }), React.createElement(ProductVideo, {
      product: product,
      bottomMargin: true
    }), React.createElement(ProductHighlightsTable, {
      product: product,
      user: this.props.user,
      bottomMargin: true
    }), React.createElement("a", {
      id: "rentabilidad"
    }), React.createElement(FundPerformanceCharts, {
      product: product,
      category: this.props.category.model
    }), React.createElement(FundRatios, {
      product: product
    }), React.createElement(FundBreakdowns, {
      fund: fund
    }), React.createElement(FundScatterComparisonChart, {
      contextFunds: [fund],
      universes: ['sameCategory', 'sameManagementCompany', 'mostViewed', 'srri']
    })), React.createElement(Side, {
      fullWidth: true
    }, React.createElement(Sticky, {
      omniNavState: this.props.omniNavState
    }, React.createElement(AsideWatchlistBlock, null, React.createElement(ProductSummary, {
      product: product,
      productsSubscriptions: this.props.subscriptions.products,
      user: this.props.user,
      actions: {
        onProductRequest: () => {
          this.handleProductRequest();
        },
        onProductSubscription: this.props.handleEntityFollow
      }
    }))))), React.createElement(ContainerInner, null, React.createElement(MainContent, {
      fullWidth: true
    }, React.createElement(FundSameManagementCompanyFunds, {
      funds: fundsByManagementCompany,
      fund: fund,
      subscriptions: this.props.subscriptions.products,
      onFollow: this.handleListFollow,
      withSPA: true,
      bottomMargin: true
    }), React.createElement(FundSameCategoryFunds, {
      funds: fundsByCategory,
      fund: fund,
      subscriptions: this.props.subscriptions.products,
      onFollow: this.handleListFollow,
      withSPA: true,
      bottomMargin: true
    }), ['fund', 'plan'].includes(productType.id) ? React.createElement(FundGettingStarted, {
      productType: productType,
      gettingStarted: gettingStarted,
      bottomMargin: true
    }) : null, React.createElement(InformationSource, {
      withFinect: !['finect'].includes(theme.partner.consumer)
    })))));
  }
}
export default withContext(withSubscriptions(connect(mapStateToProps, mapDispatchToProps)(withParams(withTheme(FundsSheet))), ['products', 'profiles']));